/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { isObject, isStringNotEmpty, objectHasPropertyString } from "utils/empty-exists";
import { useAuth } from "cms/auth/hooks/use-auth";
import { ImageSelectorWrapper } from "cms/images/image-selector/image-selector-wrapper";
import { AddImageButton } from "./add-image-button";

function CardsImage (props) {

    const {
        image: guid,
        updateImage,
    } = props;

    const { token } = useAuth();
    const [loadingImage, setLoadingImage] = useState(false);
    const [image, setImage] = useState();

    const loadImage = async () => {
        if (isStringNotEmpty(guid)) {
            const _image = await SimpliCityAdminSDK.images.findOne(token, guid);
            setImage(_image);
            return _image;
        }
    };

    useEffect(() => {
        const load = async () => {
            if (isStringNotEmpty(guid)) {
                setLoadingImage(true);
                const _image = await loadImage(guid);
                setImage(_image);
                setLoadingImage(false);
            } else {
                setImage(undefined);
            }
        };
        if (isObject(image) && image?.guid !== guid) {
            load();
        }
        // load once
        if (!isObject(image) || !objectHasPropertyString(image, "guid")) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);

    const handleUpdate = (_image) => {
        updateImage(_image);
    };
    const onChangeImage = async (_image) => {
        setImage(_image);
        handleUpdate(_image?.guid);
    };
    const onSaveImage = async (_image) => {
        setImage(_image);
        handleUpdate(_image?.guid);
    };
    const onRemoveImage = async () => {
        setImage(undefined);
        handleUpdate("");
    };
    const onReload = async (_image) => {
        setImage(_image);
        handleUpdate(_image?.guid);
    };

    return (
        <Fragment>
            {!loadingImage &&
                <ImageSelectorWrapper
                    image={image}
                    guid={guid}
                    onImageChange={onChangeImage}
                    onImageSave={onSaveImage}
                    onImageRemove={onRemoveImage}
                    onReload={onReload}
                    AddButtonComponent={AddImageButton}
                    defaultImageSelectorWidth={200}
                    defaultImageSelectorHeight={128}
                    className="cards-image-image-editor"
                />
            }
        </Fragment>
    );
}

export { CardsImage };
